import React from 'react';

import './skeleton.scss'

export function SkeletonText() {
  return (<div className="placeholder-text-line placeholder-animated-background "></div>);
}

SkeletonText.propTypes = {};

export default SkeletonText;
